<template>
    <div class="swiper-slide cz__product-slide">
        <div ref="image" class="cz__product-image">
        </div>
    </div>
</template>

<style lang="scss">
    #cz3 {
        .cz__product-slide {

        }

        .cz__product-image {
            position: absolute;

            inset: 0;
        }

        .cz__render {
            position: absolute;

            inset: 0;
        }
    }
</style>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            view: {
                type: Object,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            controllerOptions() {
                return this.customizerStore.options;
            },
        },

        mounted() {
            this.image = new this.controllerOptions.DriveCustomizer.ImageView(this.viewController, {
                container: this.$refs.image,
            });

            this.image.selectViewByCode(this.view.code);

            this.image.resize();

            window.addEventListener('resize', this.resize);
        },

        beforeUnmount() {
            window.removeEventListener('resize', this.resize);
        },

        methods: {
            resize() {
                setTimeout(() => {
                    if (this.image) {
                        this.image.resize();
                    }
                }, 100);
            },
        },
    };
</script>
